import React from 'react';
import slugify from 'react-slugify';

import { WEB_URL } from '../api/URLs';
import { MixPanelTrackedLink } from '.';
import { renderHTML } from '../helpers';
import { S3_BUCKET, TEAM_PAGE } from '../constants';
import defaultCoverImage from "../assets/images/cover.jpg"
import { PAGE_STATUS, SINGLE_OWNER_PAGE } from '../constants';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import useStyles, { Badge, BoldTitle, StyledPaper } from './StyledComponents/UserFundraiserStyles';
import { useNavigate } from 'react-router-dom';

export function UserFundraiser({ item, listType }) {
    const classes = useStyles();
    const navigate = useNavigate();
    
    let coverImage = item.cover_image ? S3_BUCKET + "medium/" + item.cover_image : defaultCoverImage;
    let raisedPercentage = (item.total_fund_raised / item.fundraising_goal) * 100;
    raisedPercentage = Math.round(raisedPercentage);
    const totalMembers = item.total_team_members;

    const pageLink = WEB_URL.FUNDRAISER_DETAILS(item.event_id, slugify(item.page_title));
    const editPageLink = WEB_URL.UPDATE_FUNDRAISER(item.event_id, slugify(item.page_title))

    const VerticalSeparator = () => {
        return <Typography component="span" color="neutral.dark">  |  </Typography>
    }

    const mapEditIcon = () => {
        return <MixPanelTrackedLink className={classes.editIcon} type="iconButton" label="Edit" context={`Edit ${item.page_title}`} onClick={() => navigate(editPageLink)}>
            <EditOutlinedIcon />
        </MixPanelTrackedLink>
    }
    return (
        <StyledPaper variant="outlined">
            <Box>
                <MixPanelTrackedLink sx={{ height: '100%', '& .MuiButtonBase-root': { height: '100%' } }} type="link" label={item.page_title} context={`Page "${item.page_title}" link clicked`} href={pageLink}>
                    <img src={coverImage} />
                </MixPanelTrackedLink>
            </Box>
            <Card>
                <CardContent>
                    <Stack spacing={1}>
                        <MixPanelTrackedLink underline="none" label={item.page_title} context={`Page "${item.page_title}" link clicked`} href={pageLink} type="link">
                            <BoldTitle>{item.page_title}</BoldTitle>
                        </MixPanelTrackedLink>
                        <Typography fontSize="small" sx={{ '& p': { marginBottom: 0 } }}>{item.description ? renderHTML(item.description.substring(0, 100) + "...") : null}</Typography>
                        <Typography fontSize="small">{(raisedPercentage > 100 ? 100 : raisedPercentage)}% Raised

                            {listType == TEAM_PAGE ? <><VerticalSeparator />
                                {totalMembers} Member(s)</> : null}

                            <VerticalSeparator />
                            {item.country_name}
                        </Typography>
                        <Box>
                            {listType == SINGLE_OWNER_PAGE || item.is_leader ? mapEditIcon() : null}
                            {listType == TEAM_PAGE ? <Badge size="small" label={item.is_leader ? "Owner" : "Member"} color="primary" variant="outlined" /> : null}
                            <Badge size="small" label={PAGE_STATUS[item.status]['status']} color={PAGE_STATUS[item.status]['color']} variant="outlined" />
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </StyledPaper>
    )
}